<div class="container-fluid cadastro-perfil">
    <mat-card>
        <mat-card-header class="header-padrao">
            <mat-card-title>
                Gerencia de arquivos
            </mat-card-title>
        </mat-card-header>

        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

        <div *ngIf="listaArquivos.length == 0" style="min-height: 120px" class="d-flex align-items-center justify-content-center">
            <span>Nenhum registro para o filtro especificado.</span>
        </div>

        <mat-card-content *ngIf="listaArquivos.length > 0">
            <div>
                <table id="relatorios" mat-table [dataSource]="listaArquivos" class="table">
                    <tbody>

                        <ng-container matColumnDef="nomeArquivo">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;" style="text-align: center;">Nome arquivo
                            </th>
                            <td mat-cell *matCellDef="let p">{{ p?.nomeArquivo }}</td>
                        </ng-container>

                        <ng-container matColumnDef="usuario">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Usuario</th>
                            <td mat-cell *matCellDef="let p">{{ p?.usuario }}</td>
                        </ng-container>

                        <ng-container matColumnDef="dataUpload">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Upload</th>
                            <td mat-cell *matCellDef="let p">{{ p?.dataUpload | date:'dd/MM/yyyy' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Baixar</th>
                            <td mat-cell *matCellDef="let p" width="100px">
                                <a href="{{getUrlDownload(p?.diretorio)}}" target="_blank">
                                    <mat-icon>file_download</mat-icon>
                                </a>
                            </td>
                        </ng-container>


                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </tbody>
                </table>
            </div>

        </mat-card-content>
    </mat-card>
</div>